// extracted by mini-css-extract-plugin
export default {"hover":"categorical__hover___1jwtR","value":"categorical__value___2m6V7"};